module.exports = __webpack_public_path__ + "static/media/icon-carbon.ec13a8bb.svg";